import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {MemberLoyaltyReportData} from "./member-loyalty-report.data";

@Injectable()
export class MemberLoyaltyReportModel extends ReportModel<MemberLoyaltyReportData> {
    constructor(injector: Injector) {
        super(injector, MemberLoyaltyReportData);
    }
}
